import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { Wordmark } from './Wordmark';

/** Shown when a page crashes, instead of the developer error screen. */
export function ErrorPage() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  // Keep the details for whoever's fixing it, without showing them to coaches.
  console.error(error);
  return (
    <div className="flex min-h-dvh flex-col px-4 py-10 sm:py-16">
      <div className="mx-auto w-full max-w-[480px]">
        <Link to="/">
          <Wordmark />
        </Link>
        <h1 className="mt-10 text-[24px] font-semibold">{notFound ? 'Page not found' : 'Something went wrong on this page'}</h1>
        <p className="mt-2 text-muted">
          {notFound
            ? 'That page doesn’t exist, or the link was copied incompletely.'
            : 'Your saved work is safe. Reload the page to try again. If it keeps happening, tell us what you were doing when it broke.'}
        </p>
        <div className="mt-6 flex flex-wrap gap-2">
          {!notFound && (
            <button className="btn-primary" onClick={() => window.location.reload()}>
              Reload the page
            </button>
          )}
          <Link to="/" className="btn-secondary">
            Go to the schedule
          </Link>
        </div>
        {!notFound && error instanceof Error && (
          <details className="mt-8 text-[13px] text-muted">
            <summary className="cursor-pointer">Details for support</summary>
            <pre className="mt-2 overflow-x-auto rounded-md bg-sunken p-3 whitespace-pre-wrap">{error.message}</pre>
          </details>
        )}
      </div>
    </div>
  );
}
